/* =========================================================================
 * size-swatch-sync.js
 * -------------------------------------------------------------------------
 * 目的（バグ修正）:
 *   PDP（商品ページ）で、PC表示のサイズ「スウォッチ（ラジオボタン）」を
 *   選んでも、実際にカートへ送られる variant（<select name="id">）と
 *   商品コード（.variant_sku）が更新されず、常に先頭 variant（＝ 25cm /
 *   その SKU）のままになる問題を修正する。
 *
 * 原因:
 *   サイズは input[name="size"] のラジオで表示されるが、本来サイズ選択と
 *   variant を同期させる <select class="single-option-selector"> がページ上に
 *   存在しない（0個）。そのため Shopify.OptionSelectors / selectCallback が
 *   発火せず、隠れている <select name="id"> と商品コード表示が先頭 = 25cm の
 *   まま変わらない。
 *
 * この修正:
 *   サイズラジオ(input[name="size"])の変更を監視し、選択サイズに対応する
 *   variant を特定して、
 *     1) ページ内すべての <select name="id">（通常フォーム＋下部固定カートバー）
 *     2) 商品コード表示（.variant_sku）
 *   を更新する。<select name="id"> には change を発火し、テーマ側の価格/在庫/
 *   ボタン更新も連動させる。
 *
 * 設置方法:
 *   1) このファイルを theme の assets/ にアップロード。
 *   2) product テンプレート（sections/product-template.liquid）で
 *        {{ 'size-swatch-sync.js' | asset_url | script_tag }}
 *      を読み込む（既に fixed-addtocart 直後に追加済み）。
 * ========================================================================= */
(function () {
  'use strict';

  var SIZE_RADIO = 'input[type="radio"][name="size"]';
  var ID_SELECT  = 'form[action*="/cart/add"] select[name="id"], form[action*="/cart/add"] [name="id"]';
  var SKU_EL     = '.variant_sku, .variant-sku';   // 商品コードの値を表示する要素

  // 選択中スウォッチの表示テキスト（例 "9(27cm)"）を全グループ分取り出す
  function checkedSwatchValues() {
    var vals = [];
    document.querySelectorAll('.swatch input[type="radio"]:checked').forEach(function (r) {
      var v = (r.value || '').trim();
      if (v) vals.push(v);
    });
    return vals;
  }

  // window.meta.product.variants から該当 variant オブジェクト（id, sku）を取得（最優先）
  function findVariantFromMeta(sizeValue, allChecked) {
    try {
      var variants = window.meta.product.variants;
      if (!variants || !variants.length) return null;
      var joined = allChecked.join(' / ');
      for (var i = 0; i < variants.length; i++) {
        var pt = (variants[i].public_title || '').trim();
        if (pt === sizeValue || pt === joined) return variants[i];
      }
      for (var j = 0; j < variants.length; j++) {
        var pt2 = (variants[j].public_title || '').trim();
        if (pt2 && pt2.indexOf(sizeValue) === 0) return variants[j];
      }
    } catch (e) {}
    return null;
  }

  // メタが無い場合の保険: <select name="id"> の option（テキスト先頭一致）から id/sku を取得
  function findVariantFromSelect(sizeValue) {
    var sel = document.querySelector(ID_SELECT);
    if (!sel || !sel.options) return null;
    for (var i = 0; i < sel.options.length; i++) {
      var o = sel.options[i];
      if (o.textContent.trim().indexOf(sizeValue) === 0) {
        return { id: o.value, sku: o.getAttribute('data-sku') || null };
      }
    }
    return null;
  }

  function syncVariantId(variantId) {
    if (!variantId) return;
    document.querySelectorAll(ID_SELECT).forEach(function (sel) {
      if (sel.tagName !== 'SELECT') {
        if (sel.value !== String(variantId)) {
          sel.value = String(variantId);
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
      var match = null;
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value === String(variantId)) { match = sel.options[i]; break; }
      }
      if (match && !match.selected) {
        sel.value = String(variantId);
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function updateSku(sku) {
    if (!sku) return;
    document.querySelectorAll(SKU_EL).forEach(function (el) {
      if (el.textContent.trim() !== String(sku)) {
        el.textContent = String(sku);
      }
    });
  }

  function onSizeChange() {
    var checked = document.querySelector(SIZE_RADIO + ':checked');
    if (!checked) return;
    var sizeValue = (checked.value || '').trim();
    if (!sizeValue) return;

    var all = checkedSwatchValues();
    var v = findVariantFromMeta(sizeValue, all) || findVariantFromSelect(sizeValue);
    if (!v) return;

    syncVariantId(v.id);
    updateSku(v.sku);
  }

  function init() {
    if (!document.querySelector(SIZE_RADIO)) return;           // サイズスウォッチが無いページは何もしない
    if (!document.querySelector(ID_SELECT)) return;

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches(SIZE_RADIO)) onSizeChange();
    });
    document.addEventListener('click', function (e) {
      var lab = e.target && e.target.closest ? e.target.closest('.swatch label') : null;
      if (lab) setTimeout(onSizeChange, 0);
    });

    onSizeChange();   // 初期表示時に選択中サイズと variant / SKU を一致させる
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
